import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b97f600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chips-msg-box-wrap" }
const _hoisted_2 = { class: "chips-msgbox-title-wrap" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "msgbox-body-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!

  return (_openBlock(), _createElementBlock("div", {
    class: "chips-msg-box-root",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('setting.chipssetting')), 1),
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }, [
          _createVNode(_component_icon_x)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chipsArray, (chip) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["chip-option", { active: chip.id === _ctx.chips.id }]),
            key: chip.id,
            onClick: _withModifiers(($event: any) => (_ctx.setChips(chip)), ["prevent"])
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chip.value, (value, valueIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "chip",
                key: valueIndex
              }, _toDisplayString(_ctx.toShortValue(value)), 1))
            }), 128))
          ], 10, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}